import { NavLink, Outlet } from "react-router-dom";
import { signOut, useSession } from "@otto/plattform";
import { TourBar } from "../../features/onboarding/components/TourBar.js";
import { useTour } from "../context/TourContext.js";
import styles from "./shell.module.css";

/** Rahmen mit Navigation. Die Punkte richten sich nach der Rolle. */
export function Shell() {
  const { client, state } = useSession();
  const identity = state.kind === "signedIn" ? state.identity : null;
  const istSchuladmin = identity?.profile?.role === "school_admin";
  const tour = useTour();

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `${styles.navLink} ${isActive ? styles.navActive : ""}`;

  return (
    <div className={styles.frame}>
      <header className={styles.header}>
        <span className={styles.brand}>Otto tippt los</span>
        <nav className={styles.nav}>
          <NavLink to="/classes" className={linkClass}>
            Klassen
          </NavLink>
          {istSchuladmin && (
            <NavLink to="/school" className={linkClass}>
              Schule
            </NavLink>
          )}
        </nav>
        <div className={styles.who}>
          {/* Der leise Verweis, der die weggelegte Leiste zurückholt. Er steht
              rechts bei den stillen Dingen und nicht in der Navigation: die
              Führung ist kein Bereich der Anwendung. Ohne ihn wäre „Später“
              endgültig, und genau das soll es nicht sein. */}
          {tour !== null && !tour.running && (
            <button type="button" className={styles.buttonQuiet} onClick={tour.reopen}>
              Erste Schritte
            </button>
          )}
          <span>{identity?.profile?.name ?? identity?.user.email}</span>
          <button
            type="button"
            className={styles.buttonQuiet}
            onClick={() => void signOut(client)}
          >
            Abmelden
          </button>
        </div>
      </header>
      {/* Die laufende Marke steht am Rahmen, das Ziel am echten Bedienelement.
          Zusammen greift die Regel in `tour.module.css` – ohne eine einzige
          gemessene Koordinate. `undefined` und nicht `null`: React lässt das
          Attribut dann ganz weg, statt es leer zu setzen. */}
      <main className={styles.content} data-tour-aktiv={tour?.mark ?? undefined}>
        {/* Unter dem Kopf, über dem Inhalt – und im Rahmen, damit ein
            Seitenwechsel sie nicht mitnimmt. Innerhalb von `.content`, weil
            sie damit dieselbe Polsterung hat wie die Seite darunter; ihre
            Breite bringt sie selbst mit. */}
        <TourBar />
        <Outlet />
      </main>
    </div>
  );
}
